import { VERIFY_THE1, VERIFY_THE1_ERROR, REGISTER_TRANSFER, REGISTER_TRANSFER_ERROR } from './type'

export function verifyThe1(type, params) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: VERIFY_THE1,
            payload: null,
            result: null
        })
        axios.post(`/the1/verify`, { type: type, params: params })
            .then((response) => {
                dispatch({
                    type: VERIFY_THE1,
                    payload: response.data,
                    result: true
                })
            })
            .catch((error) => {
                dispatch({
                    type: VERIFY_THE1_ERROR,
                    payload: (error.response && error.response.data) || null,
                    result: false
                })
            })
    }
}

export function registerThe1Transfer(info) {
    return (dispatch, getState, { axios }) => {
        dispatch({
            type: REGISTER_TRANSFER,
            payload: null,
        })
        axios.post(`/the1/transfer/register`, info)
            .then((response) => {
                dispatch({
                    type: REGISTER_TRANSFER,
                    payload: true,
                })
            })
            .catch((error) => {
                dispatch({
                    type: REGISTER_TRANSFER_ERROR,
                    payload: (error.response && error.response.data) || null,
                    result: false
                })
            })
    }
}

export function clearThe1Verify() {
    return (dispatch) => {
        dispatch({
            type: VERIFY_THE1,
            payload: null,
            result: null,
        });
        dispatch({
            type: VERIFY_THE1_ERROR,
            payload: null,
            result: null,
        });
    };
}